import SSRSafeSuspense from '~components/SSRSafeSuspense';
import { COMPANY_DETAIL_MENU } from '~constant/company';
import { useSuspensedCompanyStates } from '~hooks/query/company/useCompanyStates';
import { ValueOf } from '~types/common';

import CompanyInfo from './CompanyInfo';
import CompanyHeaderSkeleton from './CompanyInfo/Skeleton';
import CompanyMenu from './CompanyMenu';
import CompanyMenuSkeleton from './CompanyMenu/Skeleton';
import { Content, Wrapper } from './style';

function Header({ selectedMenu }: { selectedMenu: ValueOf<typeof COMPANY_DETAIL_MENU> }) {
  const { data: companyStates } = useSuspensedCompanyStates();

  if (companyStates?.deleted) return <Wrapper />;

  return (
    <Wrapper>
      <Content>
        <SSRSafeSuspense pendingFallback={<CompanyHeaderSkeleton />}>
          <CompanyInfo />
        </SSRSafeSuspense>
      </Content>

      <SSRSafeSuspense pendingFallback={<CompanyMenuSkeleton />}>
        <CompanyMenu selectedMenu={selectedMenu} />
      </SSRSafeSuspense>
    </Wrapper>
  );
}

export default Header;
